/* unplugin-vue-components disabled */import script from "./config.vue?vue&type=script&setup=true&lang=ts"
export * from "./config.vue?vue&type=script&setup=true&lang=ts"

import "./config.vue?vue&type=style&index=0&id=2edc9d28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2edc9d28"]])

export default __exports__